import React from 'react'
import { alpha, Box, Typography } from '@mui/material'
import { PopoverSeeker } from "@ui-seeker/core"
import PopoverTitle from "./Title"
import PopoverLinks from "./Links"
import PopoverCarFeatures from "./Features"
import PopoverDecisions from "./Decisions"
import { dsColorNew } from "@palette"
import { previousLine } from "Pages/AnalyzersV2/@services/passCompare"
import { AskIrisButton } from "@components"


// `getAsk` (CU-869fkdhjv phase 3, UX C2): "Ask Iris about this price" as its own band between the content (or
// "Repricing decisions") and the links; it closes the detail and asks in the same gesture. `askOrigin` names the
// cell for the Evolution Chart's own "Ask Iris".
export default function AnalyzerPopover({ isOpen, onClose, data, decisions = null, hideEvolution = false, getAsk = null, askOrigin = null }) {

	const { price_data, evolutionFilter } = data
	// a repricing pass: which earlier pass the cell compares with (CU-869fmm944, UX Obs. 6)
	const previous = previousLine(data.previous_price, data.previous_pass)
	return <PopoverSeeker
		anchorEl={isOpen}
		onClose={onClose}
		anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
		transformOrigin={{ vertical: 'center', horizontal: 'left' }}
		arrowProps={{ sx: { top: '35%', left: -6 } }}
		slotProps={{ paper: { sx: { p: 0, width: decisions?.decisions?.length ? 380 : 300, borderRadius: '12px', border: `1px solid ${dsColorNew.grayBorder}`, boxShadow: `0 16px 40px ${alpha(dsColorNew.navy, 0.16)}`, backgroundColor: dsColorNew.white } } }}
	>
		<PopoverTitle onClose={onClose} carDescription={price_data?.car_description}/>
		<PopoverCarFeatures priceData={price_data}/>
		{!!previous && <Typography sx={{ px: 1.75, pb: 1.25, fontSize: 12, color: dsColorNew.textMuted }}>{previous}</Typography>}
		{!!decisions && <PopoverDecisions cell={decisions} priceData={price_data}/>}
		{!!getAsk && <Box sx={{ px: 1.75, py: 1.25, borderTop: `1px solid ${dsColorNew.grayBorder}`, '&:empty': { display: 'none' } }}>
			<AskIrisButton variant="block" getAsk={getAsk} onBeforeAsk={onClose}/>
		</Box>}
		<PopoverLinks
			askOrigin={askOrigin}
			id_search={price_data?.id_search}
			screenshot={price_data?.screenshot}
			evolutionFilter={evolutionFilter}
			priceData={price_data}
			hideEvolution={hideEvolution}
		/>
	</PopoverSeeker>
}